import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import axios from "axios";
import { Button, Row, Col, Input, Table } from "reactstrap";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";

function ListadoPendLaredo() {
  const { user } = useContext(AuthContext);
  const URL = `${process.env.REACT_APP_URL_ARTICULOS_OC}/PendEmbarcar`;

  const [articulos, setArticulos] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });
  const ITEMS_PER_PAGE = 100;

  const headers = [
    { name: "# OC",         field: "idOrdenCompra",      sortable: true },
    { name: "Parent",       field: "codigo",             sortable: true },
    { name: "Variante",     field: "varianteNombre",     sortable: true },
    { name: "Nombre",       field: "nombre",             sortable: true },
    { name: "Proveedor",    field: "proveedor",          sortable: true },
    { name: "F. OC",        field: "fechaOC",            sortable: true },
    { name: "F. Compromiso",field: "fechaCompromiso",    sortable: true },
    { name: "Pedido",       field: "cantidad",           sortable: true },
    { name: "Enviado",      field: "embarcado",          sortable: true },
    { name: "Pend. Bodega USA", field: "pendiente_embarcar", sortable: true },
  ];

  useEffect(() => {
    showLoader();
    axios.get(URL, { headers: { Authorization: `Bearer ${localStorage.getItem("app_token")}` } })
      .then(({ data }) => { setArticulos(data); hideLoader(); })
      .catch(err => { console.log(err); hideLoader(); });
  }, []);

  const commentsData = useMemo(() => {
    let filtered = articulos;
    if (search) {
      const s = search.toLowerCase();
      filtered = filtered.filter(a =>
        (a.codigo || "").toLowerCase().includes(s) ||
        (a.nombre || "").toLowerCase().includes(s) ||
        (a.proveedor || "").toLowerCase().includes(s) ||
        String(a.idOrdenCompra || "").includes(s)
      );
    }
    setTotalItems(filtered.length);
    if (sorting.field) {
      filtered = [...filtered].sort((a, b) =>
        sorting.order === "asc"
          ? a[sorting.field] > b[sorting.field] ? 1 : -1
          : a[sorting.field] < b[sorting.field] ? 1 : -1
      );
    }
    return filtered.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);
  }, [articulos, search, sorting, currentPage]);

  const totalPend     = articulos.reduce((s, a) => s + (a.pendiente_embarcar || 0), 0);
  const totalPedido   = articulos.reduce((s, a) => s + (a.cantidad || 0), 0);
  const totalEnviado  = articulos.reduce((s, a) => s + (a.embarcado || 0), 0);

  return (
    <>
      <Header />
      <br /><br />
      {user.menu_compras ? (
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                <Row className="mb-2">
                  <Col md={12}>
                    <Button size="sm" color="danger" href="/BotonesCompras" id="botonListado">Regresar</Button>
                  </Col>
                </Row>

                <h5 style={{ fontWeight: 600 }}>Pendiente Llegar a Bodega USA</h5>
                <p style={{ fontSize: "0.8rem", color: "#64748b" }}>
                  Artículos ordenados en OC que aún no se han recibido en Bodega USA — <strong>{new Intl.NumberFormat("en-US").format(totalPend)} pzas</strong>
                </p>

                <div className="row">
                  <div className="col-md-8">
                    <Pagination total={totalItems} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage}
                      onPageChange={p => setCurrentPage(p)} />
                  </div>
                  <div className="col-md-4 d-flex flex-row-reverse">
                    <Search onSearch={v => { setSearch(v); setCurrentPage(1); }} />
                  </div>
                </div>

                <Table size="sm" bordered responsive striped>
                  <TableHeader headers={headers} onSorting={(f, o) => setSorting({ field: f, order: o })} />
                  <tbody>
                    {commentsData.map((a, i) => (
                      <tr key={i} style={a.pendiente_embarcar < 0 ? { backgroundColor: "#fff7ed" } : {}}>
                        <td><strong>{a.idOrdenCompra}</strong></td>
                        <td>{a.codigo}</td>
                        <td>{a.varianteNombre || "—"}</td>
                        <td>{a.nombre}</td>
                        <td>{a.proveedor}</td>
                        <td>{a.fechaOC ? a.fechaOC.substring(0, 10) : ""}</td>
                        <td>{a.fechaCompromiso ? a.fechaCompromiso.substring(0, 10) : ""}</td>
                        <td>{new Intl.NumberFormat("en-US").format(a.cantidad)}</td>
                        <td>{new Intl.NumberFormat("en-US").format(a.embarcado)}</td>
                        <td><strong style={{ color: a.pendiente_embarcar < 0 ? "#f97316" : "#ef4444" }}>{new Intl.NumberFormat("en-US").format(a.pendiente_embarcar)}</strong></td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr style={{ backgroundColor: "#f1f5f9", fontWeight: 700, color: "#1e293b" }}>
                      <td colSpan={7} className="text-end">TOTALES</td>
                      <td style={{ color: "#1e293b" }}>{new Intl.NumberFormat("en-US").format(totalPedido)}</td>
                      <td style={{ color: "#1e293b" }}>{new Intl.NumberFormat("en-US").format(totalEnviado)}</td>
                      <td style={{ color: totalPend < 0 ? "#f97316" : "#ef4444" }}>{new Intl.NumberFormat("en-US").format(totalPend)}</td>
                    </tr>
                  </tfoot>
                </Table>

                <Row>
                  <Col md={12}><p style={{ fontSize: "0.8rem", color: "#94a3b8" }}>{totalItems} artículos</p></Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      ) : <p className="text-muted ms-3">Sin acceso.</p>}
      {loader}
    </>
  );
}

export default ListadoPendLaredo;
